// @flow
import { type Node } from 'react';
import styled from '@emotion/styled';
import { SPACING, typography } from '@tablekit/theme/';
import PersonImage, { SIZES } from 'components/PersonImage';
import {
  getFormatDate,
  getPageContext,
  getPrintTime
} from 'components/PageContext';
import type { AuthorType } from 'components/types';
import { MOBILE_BREAKPOINT } from 'utils/theme';

type PropsType = {
  author?: AuthorType,
  readTime?: number,
  summaryButton: Node
};

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${SPACING.L6};
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 100%;
  margin-left: ${SPACING.L3};
  ${typography('L4')};

  @media ${MOBILE_BREAKPOINT} {
    ${typography('L3')};
  }
`;

const AuthorText = styled.p``;
const PublishedText = styled.p`
  margin-top: ${SPACING.L2};
`;

const PostHeader = ({ author, readTime, summaryButton }: PropsType) => {
  const { story, blogConfig } = getPageContext();
  if (!blogConfig.show_author) {
    return <Header>{summaryButton}</Header>;
  }
  const formatDate = getFormatDate();
  const { first_published_at: publishedDate } = story;
  const { name, image } = author || {
    name: 'Invalid Author Profile Selected',
    image: ''
  };
  return (
    <Header>
      <PersonImage
        alt={name}
        src={image}
        size={{ [MOBILE_BREAKPOINT]: SIZES.BLOG_MOBILE, default: SIZES.BLOG }}
      />
      <HeaderText>
        <AuthorText>{name}</AuthorText>
        {blogConfig.show_published_date && (
          <PublishedText>
            {formatDate(publishedDate)} &middot; {getPrintTime()(readTime)}
          </PublishedText>
        )}
      </HeaderText>
      {summaryButton}
    </Header>
  );
};

export default PostHeader;
